export default class EnumsServiceBase {
    container;
    async initialize() {
        this.container = await this.loadContainer();
    }
    hasValues(name) {
        return !!this.container[name];
    }
    getValues(name) {
        const values = this.container[name];
        if (!values) {
            throw new Error(`Enumerations container does not contain values for key ${String(name)}`);
        }
        return values;
    }
    getValue(name, key) {
        return this.getValues(name).find((x) => x.id === key);
    }
}
//# sourceMappingURL=enumsServiceBase.js.map